export default __webpack_public_path__ + "static/media/atletas.e0177780.png";